import axios from "axios";

export function getCheckoutDetail(id) {
  return new Promise((resolve, reject) => {
    axios
      .get(`/distributor/admin/api/v1/checkout/${id}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
